import React from "react";
import { Helmet } from "react-helmet";

// Homepage-specific preloads
const PreloadAssets = () => {
  return (
    <Helmet>
      {/* Preload WebP video poster image for homepage */}
      <link
        rel="preload"
        href="/videos/street-lawyer-services-cannabis-festival-washington-dc-poster.webp"
        as="image"
        type="image/webp"
        fetchPriority="high"
      />
      {/* Fallback JPEG poster for browsers that don't support WebP */}
      <link
        rel="preload"
        href="/videos/street-lawyer-services-cannabis-festival-washington-dc-poster.jpg"
        as="image"
        type="image/jpeg"
      />
      {/* Preload video to improve playback start time */}
      <link
        rel="preload"
        href="/videos/street-lawyer-services-cannabis-festival-washington-dc-uncompressed.mp4"
        as="video"
        type="video/mp4"
      />
    </Helmet>
  );
};

export default PreloadAssets;
